function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 7v1.13c-.32-.09-.65-.13-1-.13H6c-.35 0-.68.04-1 .13V7c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16 3.51V5H8V3.51C8 2.68 8.68 2 9.51 2h4.98c.83 0 1.51.68 1.51 1.51zM22 12v6c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4v-6c0-1.85 1.28-3.42 3-3.87.32-.09.65-.13 1-.13h12c.35 0 .68.04 1 .13 1.72.45 3 2.02 3 3.87z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.35 10.51c-.3-.23-.84-.45-1.69-.22l-2.65.73c-.83.22-1.36.92-1.36 1.78v3.35c-.18-.05-.38-.09-.58-.09-1.14 0-2.07.93-2.07 2.07a2.07 2.07 0 004.14.02c0-.01.01-.02.01-.03v-3.21L14.5 14v1.26c-.18-.05-.37-.09-.57-.09-1.14 0-2.07.93-2.07 2.07 0 1.14.93 2.07 2.07 2.07 1.14 0 2.07-.93 2.07-2.07v-5.17c0-.87-.36-1.33-.65-1.56zm-6.28 8.2a.57.57 0 110-1.14.57.57 0 010 1.14zm4.86-.89a.57.57 0 110-1.14.57.57 0 010 1.14z"
})));